module.exports = __webpack_public_path__ + "img/2.1f5fecd1.jpg";